module.exports = __webpack_public_path__ + "img/icon_e64.a6411e9c.png";